import { formatDate, isToday } from "./dates.mjs";
function isValidDate(date) {
  if (date) {
    const now = /* @__PURE__ */ new Date();
    const effectiveDate = new Date(date);
    if (!isToday(now, effectiveDate) && now.getTime() > effectiveDate.getTime()) return false;
  }
  return true;
}
function formatPhone(phone) {
  if (!phone) return null;
  return phone.replace(/(\d{3})(\d{3})(\d{4})/, "($1) $2-$3");
}
function formatHours(hours) {
  if (!hours) return [];
  return hours.retailStoreHours.map((hour) => ({
    weekdayRange: hour.effectiveDay,
    hourRange: `${hour.openAt} - ${hour.closeAt}`
  })).sort((a, b) => {
    if (a.weekdayRange < b.weekdayRange) return -1;
    if (a.weekdayRange > b.weekdayRange) return 1;
    return 0;
  });
}
function formatSpecialHours(hours) {
  if (!hours.length) return [];
  return hours.filter(
    (entry) => {
      var _a;
      return ((_a = entry.retailStoreHours[0]) == null ? void 0 : _a.effectiveDate) && isValidDate(new Date(entry.retailStoreHours[0].effectiveDate));
    }
  ).sort((a, b) => {
    if (a.retailStoreHours[0].effectiveDate && b.retailStoreHours[0].effectiveDate) {
      if (a.retailStoreHours[0].effectiveDate < b.retailStoreHours[0].effectiveDate) return -1;
      if (a.retailStoreHours[0].effectiveDate < b.retailStoreHours[0].effectiveDate) return 1;
    }
    return 0;
  }).map((entry) => ({
    storeEvent: entry.eventName,
    formattedDate: entry.retailStoreHours.map((h) => `${formatDate(new Date(h.effectiveDate))} ${h.storeClosed ? "Closed" : `${h.openAt} - ${h.closeAt}`}`)
  }));
}
export {
  formatHours,
  formatPhone,
  formatSpecialHours,
  isValidDate
};
//# sourceMappingURL=store-mapping.mjs.map
